import {
  Component,
  OnInit,
  ElementRef,
  ViewChildren,
  QueryList,
  ViewChild,
  AfterViewInit,
  AfterContentChecked,
  HostListener,
  inject
} from '@angular/core';
import { ConfirmationService, SelectItem, SortEvent } from 'primeng/api';
import {
  ApiServiceService,
  NotificationService,
  LoggingService
} from '@oneeducation/app-core';
import { DialogService } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { School, userModel, UserRoleService } from '@usermanagement/.';
import { ViewUsersComponent } from '@schoolmanagement/components/view-school-users/view-users.component';
import { BASE_ENDPOINT, USER_ENDPOINT } from '@shared/properties';
import setting from '@config/config.json';
import { Table } from 'primeng/table';
import { AccessibilityService } from '@shared/services/accessibility.service';
import { Select } from 'primeng/select';
import { ApplicationInsightsService } from '@oneeducation/app-core';
import { ExcelService } from '@shared/services/excel.service';

@Component({
  selector: 'app-manage-bases',
  templateUrl: './manage-bases.component.html',
  styleUrls: ['./manage-bases.component.scss'],
  providers: [DialogService, ExcelService],
  standalone: false
})
export class ManageBasesComponent
  implements OnInit, AfterViewInit, AfterContentChecked
{
  private apiservice = inject(ApiServiceService);
  private userService = inject(UserRoleService);
  private notificationService = inject(NotificationService);
  private loggingService = inject(LoggingService);
  dialogService = inject(DialogService);
  private accessibilityService = inject(AccessibilityService);
  private confirmationService = inject(ConfirmationService);
  private applicationInsights = inject(ApplicationInsightsService);
  excelService = inject(ExcelService);
  private elementRef = inject(ElementRef);

  @ViewChildren('schoolUsersLinks') schoolUsersLinks: QueryList<ElementRef>;
  @ViewChildren('email', { read: ElementRef }) email: QueryList<ElementRef>;
  @ViewChild('dt') allSchoolList: Table;
  @ViewChild('accessGrantDropdown') accessGrantDropdown: Select;
  @ViewChild('buttonDownloadActiveUserList')
  buttonDownloadActiveUserList: ElementRef;
  constructor() {
    this.user = new userModel();
    this.userSchool = new School();
    this.user.schools = [];
    this.activeSchoolUsers = [];
  }

  public schools: School[];
  public school: School;
  public cols: any[];
  public user: userModel;
  public userSchool: School;
  public portalAccess: SelectItem[];
  public clonedSchools: { [s: string]: School } = {};
  public queryParam;
  isFocusOnRow = false;
  private selectedRowIndex = -1;
  public activeSchoolUsers: any[];

  ref: DynamicDialogRef;

  /* tslint:disable:quotemark */
  public emailRegex = new RegExp(
    "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
  );
  /* tslint:enable:quotemark */

  ngOnInit(): void {
    this.cols = [
      {
        field: 'schoolName',
        header: 'School Name',
        sortable: true,
        width: '15%'
      },
      { field: 'laId', header: 'LA No', sortable: true, width: '10%' },
      {
        field: 'schoolNumber',
        header: 'School No',
        sortable: true,
        width: '12%'
      },
      {
        field: 'schoolUsersCount',
        header: 'Users',
        sortable: true,
        width: '7%'
      },
      {
        field: 'contactNumber',
        header: 'School Contact No',
        sortable: false,
        width: '10%'
      },
      {
        field: 'principalEmail',
        header: 'Email Address',
        sortable: false,
        width: '20%'
      },
      {
        field: 'accessGranted',
        header: 'Access to Portal',
        sortable: false,
        width: '10%'
      },
      { field: 'edit', header: '', sortable: false, width: '10%' },
      { field: 'email', header: '', sortable: false, width: '5%' }
    ];

    this.portalAccess = [
      { label: 'All', value: null },
      { label: 'Yes', value: true },
      { label: 'No', value: false }
    ];

    this.userService.userInfoReceived.subscribe((x) => {
      if (x === true) {
        this.getSchools();
      }
    });

    this.setFocusOnDownloadActiveUserListButton();
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      const value1 = data1[event.field];
      const value2 = data2[event.field];
      let result = null;

      if (
        (event.field === 'schoolUsersCount' &&
          value1 === '-' &&
          value1 !== null) ||
        (value1 === null && value2 !== null)
      ) {
        result = -1;
      } else if (
        (event.field === 'schoolUsersCount' &&
          value1 !== null &&
          value2 === '-') ||
        (value1 !== null && value2 === null)
      ) {
        result = 1;
      } else if (value1 === null && value2 === null) {
        result = 0;
      } else if (
        event.field === 'schoolUsersCount' &&
        typeof value1 === 'string' &&
        typeof value2 === 'string'
      ) {
        result = value1.localeCompare(value2, undefined, { numeric: true });
      } else if (
        (event.field === 'schoolName' || event.field === 'schoolNumber') &&
        typeof value1 === 'string' &&
        typeof value2 === 'string'
      ) {
        result = value1.localeCompare(value2);
      } else {
        result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      }

      return event.order * result;
    });
  }
  getSchools() {
    this.apiservice
      .getAll<School[]>(BASE_ENDPOINT.Schools, '', this.queryParam)
      .subscribe({
        next: (x: any) => {
          this.schools = x.school;
          this.schools.sort((a, b) =>
            a.schoolName.toLowerCase().localeCompare(b.schoolName.toLowerCase())
          );
        },
        error: (x: any) => {
          this.notificationService.showError(
            this.userService.customErrorMessage
          );
          this.loggingService?.logError(x);
        }
      });
  }

  userDetails(schoolDetails, rowIndex) {
    this.schoolUsersLinks.forEach((item) => {
      if (
        (item.nativeElement as HTMLElement).id ===
        'schoolUsers' + schoolDetails.schoolId
      ) {
        (item.nativeElement as HTMLElement).blur();
      }
    });
    this.ref = this.dialogService.open(ViewUsersComponent, {
      header: 'Users for ' + schoolDetails.schoolName,
      width: '70%',
      baseZIndex: 10000,
      closable: true,
      data: { schoolData: schoolDetails }
    });

    this.ref.onClose.subscribe(() => {
      setTimeout(() => {
        this.setFocusOnUsersLink(rowIndex.ri);
      }, 0);
    });

    return false;
  }

  // To set focus on the clicked action item
  private setFocusOnUsersLink(rowIndex: number) {
    if (this.allSchoolList) {
      const tableRow = this.allSchoolList.el.nativeElement
        .querySelector('tbody')
        .querySelectorAll('tr')[rowIndex];
      if (tableRow) {
        tableRow.querySelector('a').focus();
      }
    }
  }

  changeAccess(schools) {
    let endPoint;
    if (schools.accessGranted) {
      endPoint = 'Grant';
    } else {
      endPoint = 'Revoke';
    }
    this.apiservice
      .put(
        USER_ENDPOINT.SetSchoolAccess.replace(
          '{schoolId}',
          schools.schoolId
        ).replace('{type}', endPoint),
        ''
      )
      .subscribe({
        next: (x: any) => {
          if (schools.accessGranted) {
            this.apiservice
              .getAll<
                userModel[]
              >(USER_ENDPOINT.GetUsersByUserType.replace('{usertype}', 'School'), '')
              .subscribe({
                next: (u: any) => {
                  const userdata = u.users.filter(
                    (user) => user.email === schools.principalEmail
                  );
                  // Checking  if user already exist in requested school or not
                  let isUserExist = false;
                  userdata.forEach((user) => {
                    if (
                      user.schools.filter(
                        (y) => y.schoolId === schools.schoolId
                      ).length > 0
                    ) {
                      isUserExist = true;
                      return;
                    }
                  });

                  if (isUserExist) {
                    this.apiservice
                      .post(USER_ENDPOINT.SendWelcomeEmail, '', {
                        UserId: userdata[0].userId
                      })
                      .subscribe({
                        next: () => {
                          this.notificationService.showSuccess(
                            schools.schoolName +
                              ' has been given access to the Exclusions Portal'
                          );
                        },
                        error: (e: any) => {
                          if (e.error !== null && e.error !== '') {
                            this.notificationService.showError(e.error.message);
                          }
                        }
                      });
                  } else {
                    this.processError(x, schools);
                  }
                },
                error: () => {
                  this.notificationService.showError(
                    'Something went wrong please try to Grant access again to ' +
                      schools.schoolName
                  );
                }
              });
          } else {
            this.notificationService.showSuccess(
              schools.schoolName +
                ' no longer has access to the Exclusions Portal'
            );
          }
        },
        error: (x: any) => {
          if (schools.accessGranted) {
            if (x.error.code === '1.1.404.02') {
              this.processError(x, schools);
            }
          } else {
            schools.accessGranted = !schools.accessGranted;
            this.notificationService.showError(
              'Something went wrong please try to Revoke access again to ' +
                schools.schoolName
            );
            this.loggingService?.logError(x);
          }
        }
      });
  }

  private processError(x, schools) {
    this.user.userType = 'School';
    this.user.product = { name: setting['product'] };
    this.userSchool.active = true;
    this.userSchool.schoolId = schools.schoolId;
    this.userSchool.laId = schools.laId;
    this.userSchool.schoolName = schools.schoolName;
    this.userSchool.schoolNumber = schools.schoolNumber;
    this.user.schools = [];
    this.user.schools.push(this.userSchool);
    this.user.laId = this.userService.LaID;
    this.user.laName = this.userService.LAName;
    this.user.email = schools.principalEmail;
    this.apiservice
      .postWithResponseHeader(USER_ENDPOINT.CreateUser, this.user)
      .subscribe({
        next: (y: any) => {
          if (y.headers.get('location') !== '') {
            this.apiservice
              .post(USER_ENDPOINT.SendWelcomeEmail, '', {
                UserId: y.headers.get('location')
              })
              .subscribe({
                next: () => {
                  this.notificationService.showSuccess(
                    schools.schoolName +
                      ' has been given access to the Exclusions Portal'
                  );
                },
                error: (e: any) => {
                  if (e.error !== null && e.error !== '') {
                    this.notificationService.showError(e.error.message);
                  }
                  this.loggingService?.logError(e);
                }
              });
          }
        },
        error: (y: any) => {
          schools.accessGranted = !schools.accessGranted;
          this.loggingService?.logError(x);
          if (y.status === 409) {
            if (y.error.code === '1.1.409.01') {
              this.notificationService.showError(
                'Unable to grant access to ' +
                  schools.schoolName +
                  ' as email address is missing or invalid. Click the edit icon to record a valid email.'
              );
            } else if (y.error.code === '1.1.409.02') {
              this.notificationService.showError(
                'Unable to grant access, a user already exists with this email address.'
              );
            } else if (y.error.code === '1.1.409.03') {
              this.notificationService.showError(
                'Unable to grant access, a user already exists with this email address at another LA.'
              );
            } else {
              this.notificationService.showInformation(
                'Before granting access to ' +
                  schools.schoolName +
                  ' an email is required. Click the edit icon to record an email.'
              );
            }
          } else {
            this.notificationService.showError(
              'Something went wrong please try to Grant access again to ' +
                schools.schoolName
            );
          }
        }
      });
  }

  onSendEmail(schools) {
    this.apiservice
      .getAll<
        userModel[]
      >(USER_ENDPOINT.GetUsersByUserType.replace('{usertype}', 'School'), '')
      .subscribe({
        next: (u: any) => {
          const userdata = u.users.filter(
            (user) => user.email === schools.principalEmail
          );
          if (userdata.length > 0) {
            this.apiservice
              .post(USER_ENDPOINT.SendWelcomeEmail, '', {
                UserId: userdata[0].userId
              })
              .subscribe({
                next: () => {
                  this.notificationService.showSuccess(
                    'Welcome email re-sent successfully to ' +
                      schools.principalEmail
                  );
                },
                error: (e: any) => {
                  if (e.error !== null && e.error !== '') {
                    this.notificationService.showError(e.error.message);
                  }
                }
              });
          } else {
            schools.accessGranted = !schools.accessGranted;
            this.notificationService.showError('No email address found');
          }
        },
        error: () => {
          this.notificationService.showError(
            'Something went wrong please try to re-send the email again'
          );
        }
      });
  }

  onRowEditInit(user, rowIndex) {
    //set focus on email of current row when clicked on edit
    this.selectedRowIndex = rowIndex;
    if (this.email) {
      setTimeout(() => {
        this.email
          .find(
            (x) =>
              x.nativeElement.attributes['ri'].nodeValue === String(rowIndex)
          )
          .nativeElement.focus();
      }, 0);
    }
    this.clonedSchools[user.schoolId] = { ...user };
  }

  onRowEditSave(user) {
    if (
      user.principalEmail.trim() !== '' &&
      this.emailRegex.test(user.principalEmail)
    ) {
      this.apiservice.put(BASE_ENDPOINT.Schools, user).subscribe({
        error: (x: any) => {
          if (x.error !== null && x.error !== '') {
            this.notificationService.showError(x.error.message);
          }
        }
      });
      delete this.clonedSchools[user.schoolId];
    }

    this.setFocusOnSelectedTableRow(this.selectedRowIndex);
  }

  onRowEditCancel(user) {
    const currentSchool = this.schools.indexOf(user);
    if (currentSchool >= 0) {
      this.schools[currentSchool].principalEmail =
        this.clonedSchools[user.schoolId].principalEmail;
    }
    delete this.clonedSchools[user.schoolId];

    this.setFocusOnSelectedTableRow(this.selectedRowIndex);
  }

  disableSaveButton(user) {
    if (
      (user.principalEmail !== null && user.principalEmail.trim() === '') ||
      !this.emailRegex.test(user.principalEmail)
    ) {
      return true;
    }
    return false;
  }

  ngAfterViewInit() {
    const attributeMapAcessToPortal = new Map();
    attributeMapAcessToPortal.set('aria-label', 'Access to Portal');
    this.accessibilityService.setListBoxTableAttributes(
      this.allSchoolList,
      attributeMapAcessToPortal
    );

    const attributeMapPagesList = new Map();
    attributeMapPagesList.set('aria-label', 'Pages List');
    this.accessibilityService.setListBoxSchoolTableAttributes(
      this.allSchoolList,
      attributeMapPagesList
    );
  }

  //set focus on download active user list button
  public setFocusOnDownloadActiveUserListButton() {
    setTimeout(() => {
      if (this.buttonDownloadActiveUserList) {
        this.buttonDownloadActiveUserList?.nativeElement.focus();
      }
    }, 0);
  }

  // when download active user list button is clicked
  exportActiveSchoolUsers() {
    this.confirmationService.confirm({
      header: 'Download User List',
      icon: 'pi pi-exclamation-triangle',
      message:
        'You are about to download sensitive/confidential information and <br>you will be responsible for the security of this data outside of <br>the Exclusions Portal.',
      acceptLabel: 'Ok',
      rejectLabel: 'Cancel',
      accept: () => {
        this.downloadUserlist();
        this.confirmationService.close();
      },
      reject: () => {
        this.setFocusOnDownloadActiveUserListButton();
        this.confirmationService.close();
      }
    });
  }

  // when ok button is clicked from confirm dialog
  // generate excel file of school active user list and download
  private downloadUserlist() {
    this.apiservice
      .getAll<
        userModel[]
      >(USER_ENDPOINT.GetUsersByUserType.replace('{usertype}', 'School'), '')
      .subscribe({
        next: (x: any) => {
          this.createSchoolUserList(x.users);
          this.excelService.generateExcel(
            this.activeSchoolUsers,
            'ExclusionsPortal_School Active User List_',
            'xlsx',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
          );
          this.applicationInsights?.logTrace(
            `${this.userService.User.email} in LA ${this.userService.User.laId} has downloaded Active School UserList`
          );
          this.activeSchoolUsers = [];
        },
        error: (x: any) => {
          this.notificationService.showError(
            this.userService.customErrorMessage
          );
          this.loggingService?.logError(x);
        }
      });
  }

  // create active school user list and whose access is not revoked
  private createSchoolUserList(users) {
    const filteredusers = users.filter(
      (x) => x.product.name === setting['product']
    );
    filteredusers.forEach((user) => {
      user.schools.forEach((school) => {
        if (school.active && !school.revokeAccess) {
          // Get the one db school name using school id
          const oneDBSchoolName = this.schools?.find(
            (schoolData) => schoolData.schoolId === school.schoolId
          )?.schoolName;

          const newuser = {
            Base_Id: school.schoolId?.toString(),
            School_Number: school.schoolNumber,
            School_Name: oneDBSchoolName ? oneDBSchoolName : school.schoolName,
            First_Name: user.firstName,
            Last_Name: user.familyName,
            Email: user.email
          };
          this.activeSchoolUsers.push(newuser);
        }
      });
      this.activeSchoolUsers.sort((a, b) =>
        a.School_Name.localeCompare(b.School_Name)
      ); // sort array by school name
    });
  }

  ngAfterContentChecked(): void {
    this.setDropdownAttributes();
    this.setLandmarkRoleForDropdowns();
    this.setAccessibleNameForShowPeopleList();
    this.setAccessibleNameForGridPaginationMenu();
    this.removeRoleAttributeForDropDowns();
    this.removeAriaExpandedAttributeForDropDowns();
    this.setTablePaginationControlsTitle();
    this.setAttributesForAlertBox();
  }

  // Ensures every ARIA button, link and menuitem has an accessible name
  private setAccessibleNameForShowPeopleList() {
    if (this.accessGrantDropdown) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.accessGrantDropdown,
        'Access to Portal'
      );
    }
  }

  // Ensures every ARIA button, link and menuitem has an accessible name
  private setAccessibleNameForGridPaginationMenu() {
    if (this.allSchoolList) {
      this.accessibilityService.setAccessibleNameForGridPaginationMenu(
        this.allSchoolList,
        'Select number of school records to view'
      );
    }
  }

  // Set the attributes for the dropdown
  private setDropdownAttributes() {
    if (this.accessGrantDropdown) {
      const props = new Map<string, string>();
      props.set('title', 'Access grants');
      this.accessibilityService.setDropDownItemsAttributes(
        this.accessGrantDropdown,
        props
      );
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleKeyboardEvent() {
    if (this.ref) {
      this.ref.close();
    }
  }

  // Set focus on the current table row
  private setFocusOnSelectedTableRow(rowIndex: number) {
    if (this.allSchoolList) {
      this.accessibilityService.setFocusOnSelectedPagingTableRow(
        this.allSchoolList,
        rowIndex
      );
    }
  }

  // On press enter key, call the edit method
  public editRowData(rowIndex) {
    if (this.isFocusOnRow) {
      this.accessibilityService.editRowDataForPagingTable(
        this.allSchoolList,
        rowIndex
      );
    }
  }

  // Ensures all page content is contained by landmarks
  private setLandmarkRoleForDropdowns() {
    if (this.accessGrantDropdown) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.accessGrantDropdown
      );
    }
  }

  // Ensures role attribute has an appropriate value for the element
  private removeRoleAttributeForDropDowns() {
    if (this.accessGrantDropdown) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.accessGrantDropdown
      );
    }
    if (this.allSchoolList) {
      this.accessibilityService.removeRoleAttributeForPaginatorDropDown(
        this.allSchoolList
      );
    }
  }

  // Remove aria -expanded attribute
  private removeAriaExpandedAttributeForDropDowns() {
    if (this.accessGrantDropdown) {
      this.accessibilityService.removeAriaExpandedAttribute(
        this.accessGrantDropdown
      );
    }
    if (this.allSchoolList) {
      this.accessibilityService.removeAriaExpandedAttributeForPaginator(
        this.allSchoolList
      );
    }
  }

  // Ensures buttons have discernible text
  private setTablePaginationControlsTitle() {
    if (this.allSchoolList) {
      this.accessibilityService.setTablePaginationControlsTitle(
        this.allSchoolList,
        'Select number of school records to view'
      );
    }
  }

  // Ensures buttons have discernible text(For email sent success message)
  private setAttributesForAlertBox() {
    if (this.elementRef) {
      this.accessibilityService.setAttributesForAlertBox(this.elementRef);
    }
  }

  // When page size changes then scroll to the bottom
  public onTablePageSizeChange(event) {
    if (event.rows >= 10) {
      this.accessibilityService.onTablePageSizeChange();
    }
  }
}
